<script setup lang="ts">
import Icon from "./Icon.vue";
withDefaults(
  defineProps<{
    variant?: "primary" | "secondary" | "soft" | "ghost" | "danger";
    icon?: string;
    compact?: boolean;
    loading?: boolean;
  }>(),
  { variant: "primary" },
);
</script>
<template>
  <button
    type="button"
    class="wa-button"
    :class="[variant, { compact }]"
    :disabled="loading || undefined"
  >
    <span
      v-if="loading"
      class="spinner"
      style="width: 16px; height: 16px"
    /><Icon v-else-if="icon" :name="icon" :size="18" /><slot />
  </button>
</template>
